import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Telegram = function Telegram(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.652 1.953a.66.66 0 00-.9-.71L.633 6.965C.056 7.2.095 8.03.692 8.21L4 9.202l1.521 4.945a.499.499 0 00.84.198l2.102-2.102 4.25 2.833a.66.66 0 001.018-.45l1.92-12.673zM5.2 8.913l5.714-3.334L6.61 9.882a1.3 1.3 0 00-.35.637l-.339 1.527-.857-2.786a.3.3 0 01.135-.348z",
    fill: "currentColor"
  }));
};
export default Telegram;